var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLiber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 440,
    viewBox: "0 0 440 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M221.99 115.362V176.421",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.284 98.0572L221.99 115.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.031 95.8049L221.99 110.856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.031 95.805L255.199 77.6376",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.018 79.3243L257.346 79.9957",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.284 98.0572L257.346 79.9957",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.856 72.8345L255.199 77.6376",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.462 75.3748L258.708 76.7557",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.462 75.3748L253.214 70.6776",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.209 44.1502L253.214 70.6776",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.856 72.8344L225.335 44.6295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.788 176.421V115.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.493 98.0572L218.788 115.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.788 110.856L203.746 95.8049",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.579 77.6376L203.746 95.805",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.431 79.9957L182.76 79.3243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.431 79.9957L201.493 98.0572",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.579 77.6376L189.922 72.8345",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.316 75.3748L182.07 76.7557",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.316 75.3748L187.564 70.6776",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.521 44.1981L187.564 70.6775",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.922 72.8345L215.423 44.6486",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.788 110.856L220.389 112.457",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.389 112.457L221.99 110.856",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.521 44.1982C191.926 41.1496 175.695 27.9865 168.294 10.2222",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.197 10.155C264.844 27.872 248.709 41.0153 229.209 44.1501",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.423 44.6486C217.005 44.7828 218.606 44.8689 220.227 44.8689C221.952 44.8689 223.659 44.7827 225.336 44.6295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62 41.2837C225.297 41.4369 223.965 41.552 222.613 41.6191",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.155 41.6191C216.803 41.5711 215.461 41.4659 214.129 41.312",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.155 41.619C218.845 41.6479 219.535 41.6769 220.226 41.6769C221.031 41.6769 221.827 41.6479 222.613 41.619",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.438 9.45532C178.782 26.6067 194.878 39.1076 214.129 41.3125",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.62 41.2837C245.765 38.9828 261.756 26.4911 269.052 9.3877",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.578 128.544L200.103 181.415",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.906 104.912L169.578 128.544",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.828 104.088L167.326 124.642",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.828 104.088L179.472 79.2671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.511 80.2449L182.76 79.3243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.906 104.912L182.511 80.2449",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.472 79.267L173.318 77.2824",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.297 76.1803L182.07 76.7557",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.276 74.2438L180.297 76.1804",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.276 74.2436L140.223 63.2664",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.108 65.6154L173.318 77.2824",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.798 130.145L197.332 183.026",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.798 130.145L143.167 123.818",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.991 120.73L164.545 126.243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.991 120.73L119.18 114.077",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.509 117.202L117.579 116.953",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.167 123.818L118.509 117.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18 114.077L120.532 107.759",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 115.074L116.093 113.253",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.416 107.069L116.093 113.253",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.416 107.069L124.932 72.1539",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.527 70.6006L120.532 107.759",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.545 126.243L166.731 126.828",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.326 124.642L166.731 126.828",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5361 64.3692C85.8271 76.0363 106.449 79.3058 124.932 72.1538",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.223 63.2664C155.543 50.8036 162.944 31.3421 160.442 12.3218",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.527 70.6006C129.975 69.92 131.403 69.1914 132.803 68.3766C134.299 67.523 135.727 66.5932 137.108 65.6154",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.244 64.3692C134.385 63.6504 135.478 62.8738 136.542 62.0781",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.747 68.3575C126.974 67.8203 128.182 67.2357 129.39 66.6031",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.39 66.6024C129.994 66.2861 130.608 65.9606 131.212 65.6154C131.902 65.2129 132.573 64.8006 133.244 64.3692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8948 62.1446C87.8216 73.2941 107.993 76.0652 125.747 68.3569",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.346 13.2424C159.58 31.6972 151.977 50.5163 136.542 62.0781",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78 166.172L183.652 196.706",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.443 142.54L130.78 166.172",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.366 143.365L126.869 163.919",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.366 143.365L114.713 118.554",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.579 116.953L117.828 117.883",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.443 142.54L117.828 117.883",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.713 118.554L108.385 119.916",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.879 115.467L115.7 115.074",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.695 116.79L113.879 115.467",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7126 124.316L107.695 116.79",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.385 119.916L71.1976 127.911",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.179 168.953L182.041 199.477",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.179 168.953L105.538 175.28",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 172.202L125.268 166.7",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8929 178.846L104.713 172.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8708 181.885L79.9502 182.135",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8708 181.885L105.538 175.28",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8929 178.846L77.9083 172.692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.381 181.444L76.8062 179.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8696 173.65L76.8062 179.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9114 139.655L74.8696 173.65",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2504 136.511L77.9083 172.692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.268 166.7L127.454 166.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.869 163.919L127.454 166.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.861 160.104C31.949 162.587 51.477 155.109 63.9114 139.655",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7127 124.316C79.7496 105.881 76.432 85.355 64.7939 70.131",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1975 127.911C70.4787 129.445 69.7114 130.959 68.8486 132.455C68.0338 133.864 67.1612 135.206 66.2504 136.51",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2191 128.764C67.8425 127.565 68.408 126.348 68.9354 125.131",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7225 135.964C63.5182 134.89 64.2758 133.778 65.0044 132.628",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2191 128.764C66.8548 129.464 66.4806 130.164 66.0782 130.854C65.7329 131.458 65.3686 132.043 65.0043 132.628",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5693 72.4892C73.6997 87.339 76.5084 107.414 68.9348 125.131",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7816 156.997C32.3034 159.221 51.1896 151.533 62.7225 135.964",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.047 218.162H115.988",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6832 200.868L115.988 218.163",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4302 203.12L111.482 218.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4302 203.12L78.2634 184.953",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6308 182.806L79.9502 182.135",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6308 182.806L98.6831 200.868",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2634 184.953L73.4603 189.296",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.381 181.444L76.0007 182.69",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3126 186.937L76.0006 182.69",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.776 210.943L71.3126 186.937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2554 214.817L73.4603 189.296",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.988 221.364H177.047",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6832 238.659L115.988 221.364",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.482 221.364L96.4302 236.406",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4302 236.406L78.2634 254.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.6308 256.721L79.9502 257.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6831 238.659L80.6308 256.721",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4603 250.24L78.2634 254.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.381 258.082L76.0007 256.836",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3126 252.589L76.0006 256.836",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3127 252.589L44.8241 228.631",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2745 224.729L73.4603 250.24",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.482 221.364L113.082 219.763",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.082 219.763L111.482 218.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 167.956C28.4979 175.309 41.6413 191.444 44.776 210.943",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.848 271.859C28.6129 264.457 41.7754 248.226 44.824 228.631",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2745 224.729C45.4087 223.147 45.4948 221.547 45.4948 219.926C45.4948 218.201 45.4087 216.494 45.2548 214.817",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9095 213.541C42.0634 214.854 42.1877 216.187 42.2449 217.539",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9483 226.023C42.1015 224.69 42.1975 223.348 42.2554 221.997",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2548 221.997C42.2831 221.306 42.3028 220.616 42.3028 219.926C42.3028 219.121 42.2837 218.325 42.2455 217.539",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9096 213.541C39.6087 194.386 27.117 178.396 10.0142 171.1",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9484 226.023C39.7435 245.274 27.2321 261.38 10.0813 268.714",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.051 240.049L129.179 270.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.548 264.246L129.179 270.573",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 267.324L125.268 272.826",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.713 267.324L79.9028 260.68",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8807 257.641L79.9502 257.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.548 264.246L80.8806 257.641",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9028 260.68L77.9083 266.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8062 259.855L77.381 258.082",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8696 265.876L76.8062 259.855",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8696 265.876L63.8923 299.929",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2413 303.044L77.9084 266.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.652 242.82L130.78 273.354",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.78 273.354L124.443 296.986",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.366 296.161L126.869 275.607",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.713 320.981L121.366 296.161",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.828 321.643L117.589 322.573",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.828 321.643L124.443 296.986",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.385 319.62L114.713 320.981",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.879 324.059L115.7 324.452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.879 324.059L107.695 322.736",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7797 315.22L107.695 322.736",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.385 319.62L71.2265 311.625",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.463 273.421L126.869 275.607",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.268 272.826L127.463 273.421",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0043 369.616C76.6622 354.325 79.9311 333.703 72.7791 315.22",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9477 279.71C31.968 277.208 51.4295 284.609 63.8923 299.929",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2413 303.044C67.2191 304.425 68.149 305.854 69.0117 307.349C69.8173 308.758 70.5459 310.177 71.2265 311.625",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.704 303.61C63.5096 304.674 64.2763 305.767 65.005 306.908",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9828 314.405C68.4462 313.178 67.8708 311.97 67.2382 310.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2382 310.762C66.912 310.158 66.5957 309.544 66.2413 308.94C65.848 308.25 65.4265 307.579 65.0043 306.908",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.704 303.61C51.1421 288.175 32.3231 280.573 13.8683 282.816",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7705 367.267C73.9299 352.34 76.6905 332.16 68.9828 314.405",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.808 309.372L197.332 256.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.176 315.709L166.808 309.372",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.545 313.283L144.001 318.796",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.001 318.796L119.18 325.439",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.509 322.324L117.589 322.573",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.176 315.709L118.509 322.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.542 331.767L119.18 325.439",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.7 324.452L116.093 326.274",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.093 326.274L117.416 332.457",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.942 367.44L117.416 332.457",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.537 368.954L120.542 331.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.103 258.111L169.578 310.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.906 334.614L169.578 310.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.828 335.439L167.326 314.884",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.472 360.259L172.828 335.439",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.511 359.281L182.76 360.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.906 334.614L182.511 359.281",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.472 360.259L173.318 362.244",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.07 362.771L180.307 363.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.307 363.346L174.286 365.282",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.291 376.241L174.286 365.282",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.318 362.244L137.137 373.902",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.741 312.698L167.326 314.884",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.741 312.698L164.545 313.283",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7563 375.368C85.9803 363.72 106.506 360.403 124.942 367.44",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.291 376.241C155.735 388.675 163.213 408.203 160.739 427.291",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.537 368.954C130.071 369.673 131.595 370.441 133.081 371.303C134.49 372.118 135.833 372.991 137.137 373.902",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.39 372.933C128.192 372.31 126.984 371.744 125.757 371.217",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.59 377.429C135.516 376.634 134.404 375.876 133.254 375.148",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.254 375.148C132.669 374.783 132.084 374.419 131.489 374.074C130.79 373.671 130.09 373.297 129.39 372.933",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.633 426.37C159.848 407.849 152.159 388.962 136.59 377.43",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.756 371.217C108.049 363.644 87.965 366.452 73.1151 377.593",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.788 263.105V324.165",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.493 341.469L218.788 324.165",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.746 343.722L218.788 328.67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.746 343.722L185.579 361.889",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.441 359.521L182.76 360.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.493 341.469L183.441 359.521",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.579 361.889L189.922 366.692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.07 362.771L183.316 364.151",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.564 368.839L183.316 364.151",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.569 395.376L187.564 368.839",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.922 366.692L215.442 394.897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.99 324.165V263.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.99 324.165L239.294 341.469",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.99 328.67L237.041 343.722",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.209 361.889L237.041 343.722",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.346 359.521L258.018 360.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.346 359.521L239.294 341.469",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.209 361.889L250.866 366.692",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.462 364.151L258.708 362.771",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.462 364.151L253.224 368.839",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.257 395.328L253.224 368.839",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.866 366.692L225.364 394.878",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.99 328.67L220.389 327.07",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.389 327.07L218.788 328.67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.257 395.328C248.852 398.377 265.083 411.54 272.484 429.304",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.591 429.371C175.944 411.655 192.078 398.511 211.569 395.376",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.364 394.878C223.773 394.743 222.172 394.657 220.552 394.657C218.826 394.657 217.129 394.743 215.442 394.897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.167 398.242C215.49 398.089 216.822 397.964 218.165 397.907",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.623 397.897C223.984 397.954 225.326 398.06 226.649 398.204",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.623 397.897C221.932 397.868 221.242 397.849 220.552 397.849C219.746 397.849 218.961 397.868 218.165 397.906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.167 398.242C195.022 400.543 179.021 413.035 171.735 430.138",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.34 430.071C262.006 412.92 245.9 400.409 226.649 398.204",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.209 310.973L240.684 258.111",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.872 334.614L271.209 310.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.959 335.439L273.462 314.884",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.959 335.439L261.306 360.25",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.266 359.271L258.018 360.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.872 334.614L258.266 359.271",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.306 360.25L267.47 362.244",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.482 363.346L258.708 362.771",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 365.282L260.482 363.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 365.282L300.564 376.26",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.67 373.911L267.47 362.244",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.98 309.372L243.455 256.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.98 309.372L297.612 315.709",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.787 318.786L276.233 313.283",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.787 318.786L321.607 325.439",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.199 322.573L322.279 322.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.279 322.324L297.612 315.709",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.607 325.439L320.246 331.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.087 324.452L324.694 326.274",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.362 332.457L324.694 326.274",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.362 332.457L315.855 367.372",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.251 368.926L320.246 331.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.233 313.283L274.047 312.689",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.462 314.884L274.047 312.689",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.564 376.26C285.235 388.722 277.844 408.184 280.336 427.204",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.242 375.148C354.95 363.49 334.329 360.221 315.855 367.372",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.251 368.926C310.813 369.606 309.385 370.335 307.976 371.14C306.489 372.003 305.051 372.933 303.671 373.911",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.534 375.148C306.402 375.876 305.3 376.643 304.236 377.449",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.031 371.169C313.813 371.706 312.596 372.281 311.398 372.924",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.398 372.924C310.784 373.24 310.18 373.566 309.576 373.911C308.876 374.304 308.205 374.726 307.534 375.148",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.893 377.382C352.966 366.232 332.786 363.462 315.031 371.169",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.442 426.284C281.198 407.83 288.811 389.01 304.236 377.449",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.007 273.345L257.126 242.82",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.007 273.345L316.334 296.986",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.422 296.152L313.909 275.607",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.422 296.152L326.075 320.972",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.95 321.643L323.199 322.573",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.95 321.643L316.334 296.986",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.075 320.972L332.403 319.611",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.899 324.059L325.087 324.452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.083 322.736L326.899 324.059",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.066 315.21L333.083 322.736",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59 311.615L332.402 319.611",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.609 270.574L258.737 240.049",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.609 270.573L335.24 264.246",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51 272.826L336.065 267.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.885 260.68L336.065 267.324",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.827 257.392L359.907 257.641",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.24 264.246L359.907 257.641",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.87 266.834L360.885 260.68",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.972 259.846L363.397 258.082",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.908 265.876L363.972 259.846",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.908 265.876L376.866 299.871",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.527 303.016L362.87 266.834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51 272.826L313.324 273.411",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.324 273.411L313.909 275.607",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.917 279.413C408.829 276.94 389.311 284.417 376.866 299.871",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.066 315.21C361.038 333.646 364.346 354.172 375.994 369.396",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59 311.615C370.299 310.081 371.076 308.557 371.929 307.071C372.744 305.662 373.616 304.32 374.527 303.016",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.852 314.396C372.37 313.169 372.936 311.961 373.558 310.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.783 306.898C376.502 305.748 377.259 304.636 378.055 303.562",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.783 306.898C375.409 307.484 375.045 308.068 374.7 308.672C374.297 309.362 373.923 310.062 373.559 310.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.996 282.519C408.474 280.304 389.588 287.993 378.055 303.562",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.852 314.396C364.278 332.103 367.078 352.178 378.218 367.038",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.731 221.364H324.791",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 221.364L342.095 238.659",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.348 236.406L329.296 221.364",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.348 236.406L362.514 254.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.156 256.711L360.827 257.392",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.156 256.711L342.095 238.659",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.515 254.573L367.318 250.231",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.777 256.836L363.397 258.082",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.475 252.589L364.777 256.836",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.475 252.589L396.011 228.583",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.523 224.71L367.318 250.231",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 218.162H263.731",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.791 218.162L342.095 200.858",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.306 218.162L344.348 203.12",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.524 184.943L344.348 203.12",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.147 182.806L360.827 182.135",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.095 200.858L360.147 182.806",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.318 189.286L362.524 184.943",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.397 181.444L364.777 182.69",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.777 182.69L369.475 186.937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.954 210.895L369.475 186.937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.318 189.286L395.503 214.788",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.306 218.162L327.695 219.763",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.695 219.763L329.296 221.364",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.954 210.895C399.002 191.3 412.166 175.069 429.93 167.668",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.011 228.583C399.137 248.073 412.29 264.208 429.997 271.561",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.522 224.71C395.379 223.033 395.282 221.326 395.282 219.6C395.282 217.98 395.369 216.379 395.503 214.788",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.878 225.985C398.715 224.672 398.6 223.33 398.532 221.988",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.83 213.503C398.686 214.836 398.581 216.168 398.533 217.529",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.533 217.529C398.504 218.22 398.475 218.909 398.475 219.6C398.475 220.405 398.504 221.191 398.533 221.987",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.764 268.417C413.671 261.13 401.169 245.13 398.878 225.985",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.83 213.503C401.035 194.252 413.546 178.146 430.697 170.812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.609 168.943L258.737 199.477",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.609 168.943L335.24 175.28",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51 166.69L336.065 172.193",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.065 172.193L360.885 178.846",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.907 181.885L360.827 182.135",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.24 175.28L359.907 181.885",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.87 172.692L360.885 178.846",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.397 181.444L363.972 179.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.908 173.65L363.972 179.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.886 139.588L365.908 173.65",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.87 172.692L374.537 136.482",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.998 166.172L257.126 196.697",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.998 166.172L316.344 142.54",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.422 143.365L313.909 163.919",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.075 118.545L319.422 143.365",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.199 116.953L322.95 117.873",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.344 142.54L322.95 117.873",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.075 118.545L332.393 119.906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.078 115.074L326.899 115.458",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.083 116.79L326.899 115.458",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.999 124.297L333.083 116.79",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.393 119.906L369.551 127.901",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.909 163.919L313.324 166.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.51 166.69L313.324 166.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.999 124.297C360.847 105.822 364.116 85.2012 375.774 69.9102",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.886 139.588C389.348 154.917 408.81 162.309 427.83 159.817",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.537 136.482C373.569 135.102 372.639 133.673 371.766 132.177C370.961 130.768 370.233 129.349 369.552 127.902",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.783 132.618C376.512 133.75 377.279 134.852 378.075 135.916",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.55 128.755C372.917 127.557 372.332 126.349 371.794 125.122",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.55 128.755C373.866 129.369 374.191 129.982 374.537 130.587C374.939 131.277 375.351 131.948 375.782 132.619",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.007 72.2689C366.858 87.1957 364.087 107.367 371.794 125.122",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.074 135.916C389.636 151.342 408.455 158.954 426.91 156.71",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.98 130.145L243.455 183.026",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.98 130.145L297.612 123.818",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.787 120.73L276.233 126.243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.598 114.077L296.787 120.73",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.199 116.953L322.279 117.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.612 123.818L322.279 117.202",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.246 107.75L321.598 114.077",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.078 115.074L324.694 113.253",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.362 107.069L324.694 113.253",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.836 72.0868L323.362 107.069",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.246 107.75L312.241 70.5624",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.2 128.544L240.675 181.415",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.872 104.912L271.2 128.544",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.95 104.088L273.452 124.642",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.95 104.088L261.306 79.2671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.266 80.2449L258.018 79.3243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.872 104.912L258.266 80.2449",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.461 77.2824L261.306 79.267",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.708 76.7557L260.482 76.1803",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.502 74.2438L260.482 76.1804",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.497 63.2855L266.502 74.2437",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.461 77.2825L303.641 65.6252",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.452 124.642L274.037 126.828",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.037 126.828L276.233 126.243",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.836 72.0868C334.272 79.1139 354.798 75.8062 370.022 64.1582",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.497 63.2856C285.043 50.8511 277.565 31.3231 280.049 12.2351",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.641 65.6252C304.945 66.536 306.297 67.408 307.697 68.2234C309.193 69.0769 310.707 69.8529 312.241 70.5625",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.022 68.2997C313.804 67.7822 312.586 67.2166 311.388 66.5933",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.188 62.0973C305.271 62.893 306.374 63.6499 307.524 64.3693",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.524 64.3692C308.109 64.7434 308.694 65.1077 309.298 65.4529C309.988 65.8553 310.688 66.2295 311.388 66.5938",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.021 68.2997C332.738 75.8739 352.813 73.0739 367.663 61.9434",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.154 13.1557C280.93 31.6775 288.618 50.5637 304.188 62.0966",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.389 259.913C242.563 259.913 260.539 241.937 260.539 219.763C260.539 197.589 242.563 179.613 220.389 179.613C198.215 179.613 180.239 197.589 180.239 219.763C180.239 241.937 198.215 259.913 220.389 259.913Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.103 181.415C205.711 178.443 212.048 176.67 218.788 176.42",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.332 183.026C191.811 186.497 187.122 191.184 183.652 196.706",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.051 240.049C179.07 234.441 177.296 228.095 177.047 221.364",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.332 256.5C191.811 253.029 187.132 248.341 183.652 242.82",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.737 199.477C261.708 205.086 263.483 211.422 263.731 218.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.731 221.364C263.483 228.095 261.708 234.441 258.737 240.049",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.126 196.697C253.655 191.175 248.977 186.497 243.455 183.026",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.675 181.415C235.067 178.443 228.729 176.67 221.99 176.42",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.047 218.162C177.296 211.432 179.07 205.086 182.042 199.478",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.684 258.111C235.067 261.082 228.729 262.856 221.99 263.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.103 258.111C205.711 261.082 212.058 262.856 218.788 263.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.455 256.5C248.977 253.029 253.655 248.341 257.126 242.82",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.591 429.371C165.955 428.729 163.337 428.039 160.739 427.291",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.764 268.417C434.369 252.78 436.276 236.492 436.276 219.763C436.276 202.929 434.34 186.545 430.697 170.812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.34 430.071C253.617 433.714 237.223 435.651 220.389 435.651C203.66 435.651 187.372 433.743 171.735 430.138",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.917 279.413C428.665 276.825 429.355 274.197 429.997 271.561",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0043 369.616C66.8831 371.562 68.8006 373.479 70.7563 375.368",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0142 171.1C6.40927 186.746 4.50159 203.034 4.50159 219.764C4.50159 236.598 6.4382 252.982 10.0813 268.715",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.438 9.45536C187.17 5.81229 203.554 3.87567 220.389 3.87567C237.118 3.87567 253.406 5.78397 269.052 9.38828",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.536 64.3692C68.5896 66.2578 66.6727 68.1753 64.7933 70.131",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9477 279.71C12.2 277.112 11.4997 274.495 10.848 271.859",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.93 167.668C429.278 165.031 428.578 162.414 427.83 159.816",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.346 13.2424C125.422 22.9735 96.6413 39.9034 72.8948 62.1452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5692 72.4892C40.3656 96.2646 23.4739 125.064 13.7816 156.998",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 167.956C11.4234 165.319 12.1139 162.702 12.8609 160.104",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8677 282.816C23.5988 314.731 40.5293 343.511 62.7705 367.267",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1151 377.592C96.8905 399.786 125.69 416.678 157.633 426.37",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.774 69.9102C373.894 67.9637 371.977 66.0468 370.021 64.1575",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.994 369.396C374.115 371.351 372.188 373.269 370.242 375.148",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.442 426.284C315.356 416.544 344.137 399.614 367.892 377.382",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.484 429.304C275.121 428.652 277.738 427.952 280.336 427.204",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.218 367.037C400.422 343.262 417.304 314.463 426.996 282.519",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.197 10.155C274.833 10.7975 277.451 11.488 280.049 12.2356",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.663 61.9434C343.887 39.7403 315.089 22.848 283.155 13.1557",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.91 156.71C417.17 124.796 400.249 96.0154 378.007 72.2689",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.294 10.2222C165.658 10.8739 163.04 11.5736 160.443 12.3219",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 439C340.95 439 439 340.95 439 220C439 99.0496 340.95 1 220 1C99.0496 1 1 99.0496 1 220C1 340.95 99.0496 439 220 439Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.689 174.013L131.008 173.62",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89 196.648L131.689 174.013",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.508 214.786H166.297H120.434",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.013 175.777C126.138 175.499 126.282 175.231 126.416 174.953",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.922 188.998C122.322 184.444 124.028 180.034 126.013 175.777",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.705 211.134C116.714 210.97 116.724 210.808 116.733 210.645",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.938 196.437C117.884 201.067 117.145 205.803 116.734 210.644",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0486 186.85C97.7901 187.809 97.6363 188.825 97.6363 189.87C97.6363 196.313 102.862 201.527 109.303 201.527C113.311 201.527 116.839 199.514 118.938 196.437",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0486 186.85C99.3815 181.875 103.906 178.203 109.304 178.203C115.458 178.203 120.482 182.958 120.923 188.998",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.971 189.87C120.971 189.573 120.952 189.285 120.923 188.997",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.416 174.953C127.087 173.956 128.218 173.303 129.513 173.303C130.04 173.303 130.548 173.418 131.008 173.62",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.705 211.134C116.695 211.105 116.695 211.076 116.695 211.047C116.695 210.913 116.714 210.779 116.733 210.645",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.433 214.786H120.424",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.705 211.134C116.743 213.156 118.392 214.786 120.424 214.786",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.197 210.664C172.49 213.099 169.691 214.7 166.508 214.777",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.297 214.786C166.364 214.786 166.431 214.777 166.508 214.777",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.606 207.634C175.309 208.727 174.839 209.753 174.197 210.664",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.89 196.648L170.91 196.658",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.909 196.658C173.679 198.172 175.626 201.01 175.903 204.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.606 207.634C175.817 206.829 175.942 205.995 175.942 205.132C175.942 204.854 175.922 204.586 175.903 204.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.508 214.777V214.786",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76 224.373H119.974",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.029 224.373H120.76",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.12 242.377L131.401 265.31",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.302 242.272L171.206 242.32",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.724 228.735C116.705 228.428 116.685 228.122 116.666 227.825",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.938 242.722C117.874 238.092 117.136 233.414 116.724 228.735",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 264.006C126.272 263.862 126.196 263.718 126.129 263.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.932 250.172C122.332 254.697 124.067 259.174 126.129 263.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0486 252.31C98.3077 253.268 98.6812 254.217 99.1993 255.128C102.42 260.708 109.562 262.615 115.142 259.394C118.603 257.391 120.655 253.882 120.933 250.172",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0486 252.309C96.7157 247.334 98.7963 241.889 103.475 239.194C108.796 236.117 115.526 237.727 118.938 242.722",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.408 243.461C119.264 243.202 119.092 242.962 118.938 242.722",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.666 227.825C116.752 226.626 117.404 225.495 118.526 224.843C118.986 224.584 119.474 224.431 119.973 224.373",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 264.006C126.33 263.986 126.311 263.967 126.291 263.948C126.224 263.823 126.186 263.698 126.128 263.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.401 265.31V265.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.339 264.005C127.394 265.74 129.637 266.335 131.401 265.31",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.903 234.862C175.645 237.823 174.015 240.613 171.301 242.263",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.12 242.377C171.148 242.358 171.187 242.339 171.206 242.32C171.244 242.301 171.263 242.281 171.302 242.263",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.606 231.525C175.903 232.628 175.999 233.749 175.903 234.861",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.029 224.373H166.058",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.058 224.373C169.212 224.296 172.308 225.783 174.207 228.505",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.606 231.525C175.395 230.729 175.089 229.943 174.647 229.195C174.513 228.955 174.36 228.725 174.206 228.505",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.302 242.263V242.271",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.482 273.449L135.802 273.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 250.814L136.482 273.449",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.201 263.679L189.095 263.861L166.164 303.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.169 279.239C134.996 278.99 134.833 278.731 134.66 278.482",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.075 290.254C140.834 286.774 137.863 283.093 135.169 279.239",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 304.98C160.996 304.893 160.862 304.807 160.727 304.711",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.53 295.7C153.01 298.921 156.749 301.931 160.727 304.711",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.778 308.997C131.478 309.706 132.284 310.339 133.185 310.857C138.764 314.078 145.897 312.17 149.118 306.591C151.122 303.12 151.141 299.055 149.53 295.7",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.778 308.997C127.135 305.354 126.215 299.602 128.919 294.923C131.986 289.602 138.63 287.628 144.076 290.254",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.852 290.657C144.593 290.504 144.334 290.379 144.075 290.255",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.661 278.482C134.133 277.408 134.133 276.095 134.776 274.973C135.044 274.513 135.399 274.139 135.802 273.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 304.98C161.111 304.97 161.082 304.97 161.063 304.951C160.938 304.884 160.833 304.788 160.727 304.711",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.13 304.98C162.903 305.958 165.137 305.344 166.163 303.59V303.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.479 254.956C190.735 257.649 190.725 260.881 189.191 263.67",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.095 263.862C189.134 263.804 189.153 263.737 189.191 263.669",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.551 252.223C188.357 253.029 189.009 253.949 189.478 254.956",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.683 250.814L175.703 250.804",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.702 250.804C178.396 249.155 181.828 248.897 184.829 250.306",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.551 252.223C186.967 251.639 186.314 251.111 185.567 250.68C185.318 250.537 185.078 250.421 184.828 250.306",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.191 263.67L189.2 263.679",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.628 308.086L174.236 308.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.263 268.885L174.628 308.086",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 273.266V273.478V319.341",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.393 313.762C176.114 313.637 175.846 313.493 175.568 313.359",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.613 318.852C185.059 317.453 180.649 315.746 176.393 313.762",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.749 323.08C211.586 323.061 211.423 323.051 211.26 323.041",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.062 320.837C201.683 321.891 206.429 322.63 211.26 323.042",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.465 341.727C188.433 341.986 189.44 342.139 190.485 342.139C196.927 342.139 202.152 336.914 202.152 330.472C202.152 326.465 200.129 322.937 197.061 320.838",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.465 341.727C182.49 340.394 178.818 335.869 178.818 330.471C178.818 324.326 183.573 319.293 189.613 318.852",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.485 318.804C190.188 318.804 189.901 318.823 189.613 318.852",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.568 313.359C174.58 312.687 173.919 311.556 173.919 310.262C173.919 309.735 174.034 309.227 174.235 308.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.749 323.08C211.72 323.08 211.692 323.08 211.672 323.08C211.528 323.08 211.394 323.061 211.26 323.041",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 319.341V319.35",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.749 323.08C213.772 323.032 215.401 321.383 215.401 319.35",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.279 265.578C213.714 267.284 215.325 270.084 215.392 273.266",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 273.478C215.401 273.41 215.391 273.343 215.391 273.266",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.25 264.169C209.353 264.466 210.369 264.935 211.279 265.578",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.263 268.886L197.272 268.866",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.273 268.866C198.787 266.096 201.625 264.149 204.932 263.871",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.25 264.169C207.454 263.958 206.62 263.833 205.757 263.833C205.479 263.833 205.201 263.852 204.932 263.872",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.392 273.266H215.401",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 319.015V319.801",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 273.746V319.015",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.964 268.607L265.934 308.374",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.887 268.473L242.935 268.569",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35 323.051C229.044 323.08 228.746 323.089 228.44 323.108",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.338 320.837C238.708 321.901 234.029 322.639 229.351 323.052",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63 313.436C264.477 313.503 264.334 313.579 264.189 313.647",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.786 318.842C255.321 317.443 259.799 315.708 264.189 313.647",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.925 341.727C253.884 341.468 254.833 341.094 255.743 340.577C261.322 337.355 263.231 330.213 260.01 324.633C258.006 321.172 254.497 319.121 250.787 318.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.925 341.727C247.949 343.069 242.503 340.979 239.81 336.301C236.732 330.98 238.343 324.25 243.337 320.838",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.076 320.367C243.817 320.511 243.587 320.683 243.338 320.837",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.44 323.109C227.242 323.023 226.11 322.371 225.458 321.249C225.199 320.789 225.046 320.3 224.988 319.801",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63 313.436C264.601 313.446 264.582 313.465 264.563 313.484C264.439 313.551 264.314 313.589 264.189 313.647",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.63 313.436C266.356 312.381 266.951 310.138 265.934 308.374",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.476 263.871C238.439 264.13 241.229 265.76 242.878 268.473",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.002 268.655C242.993 268.636 242.983 268.617 242.964 268.607C242.954 268.588 242.954 268.579 242.935 268.569C242.916 268.531 242.896 268.511 242.878 268.473",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14 264.169C233.242 263.871 234.374 263.775 235.476 263.871",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 273.747V273.717",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 273.717C224.911 270.563 226.398 267.466 229.121 265.568",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14 264.169C231.345 264.38 230.558 264.696 229.81 265.127C229.57 265.261 229.35 265.415 229.121 265.568",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.878 268.473H242.887",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.063 303.292L274.457 303.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.429 264.092L274.063 303.292",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.487 250.679L304.205 273.612",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.295 250.574L264.391 250.632",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.855 304.606C279.615 304.788 279.356 304.942 279.098 305.114",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.87 295.7C287.39 298.94 283.708 301.912 279.855 304.606",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.586 278.683C305.49 278.807 305.413 278.922 305.327 279.047",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.315 290.245C299.546 286.765 302.557 283.026 305.327 279.047",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.612 308.997C310.321 308.297 310.954 307.492 311.481 306.591C314.694 301.011 312.785 293.878 307.206 290.657C303.735 288.653 299.681 288.634 296.315 290.245",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.612 308.997C305.979 312.64 300.217 313.561 295.538 310.857C290.218 307.789 288.243 301.154 290.87 295.7",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.272 294.923C291.119 295.181 291.004 295.441 290.869 295.7",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.097 305.114C278.023 305.641 276.71 305.641 275.598 304.999C275.127 304.73 274.754 304.375 274.457 303.973",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.604 278.645C305.595 278.655 305.595 278.664 305.586 278.684C305.576 278.693 305.576 278.712 305.567 278.722C305.5 278.837 305.413 278.942 305.327 279.048",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.604 278.645C306.583 276.871 305.969 274.628 304.205 273.612",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.58 250.296C258.274 249.04 261.495 249.05 264.286 250.583",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.487 250.679C264.448 250.66 264.42 250.641 264.391 250.631C264.352 250.621 264.314 250.602 264.286 250.583",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.838 252.223C253.644 251.418 254.564 250.766 255.58 250.297",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.429 264.093L251.42 264.073",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.42 264.073C249.771 261.379 249.512 257.946 250.921 254.946",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.838 252.223C252.253 252.808 251.726 253.47 251.295 254.208C251.161 254.457 251.036 254.697 250.921 254.946",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.286 250.583L264.294 250.574",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.711 265.146L309.392 265.539",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5 242.511L308.711 265.146",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.882 224.373H274.102H319.965",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.377 263.382C314.252 263.66 314.108 263.929 313.983 264.207",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.468 250.162C318.068 254.716 316.361 259.126 314.377 263.383",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.695 228.084C323.676 228.227 323.676 228.371 323.657 228.515",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.452 242.722C322.506 238.092 323.244 233.346 323.657 228.515",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.342 252.309C342.601 251.351 342.754 250.335 342.754 249.29C342.754 242.847 337.53 237.632 331.087 237.623C327.079 237.623 323.562 239.645 321.452 242.723",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.342 252.31C341.019 257.285 336.484 260.957 331.087 260.957C324.942 260.957 319.919 256.202 319.468 250.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42 249.29C319.42 249.587 319.449 249.874 319.468 250.162",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.984 264.207C313.303 265.204 312.172 265.855 310.878 265.855C310.351 265.855 309.842 265.74 309.392 265.539",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.695 228.026C323.695 228.045 323.695 228.065 323.695 228.084C323.695 228.094 323.695 228.103 323.695 228.113C323.705 228.247 323.676 228.381 323.657 228.515",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.695 228.026C323.647 226.003 321.998 224.373 319.965 224.373",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.193 228.496C267.899 226.061 270.698 224.45 273.881 224.383",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.102 224.373C274.026 224.373 273.959 224.382 273.882 224.382",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.783 231.525C265.081 230.422 265.56 229.406 266.193 228.495",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.501 242.511L269.481 242.502",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.481 242.502C266.711 240.988 264.764 238.149 264.487 234.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.783 231.525C264.572 232.33 264.448 233.164 264.448 234.017C264.448 234.305 264.467 234.574 264.487 234.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.882 224.382V224.373",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.63 214.786H320.417",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.361 214.786H319.63",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.088 196.887L269.203 196.82L308.989 173.841",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.666 210.424C323.695 210.731 323.705 211.028 323.724 211.335",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.461 196.437C322.516 201.067 323.254 205.746 323.666 210.424",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.07 175.183C314.098 175.26 314.137 175.326 314.185 175.403",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.458 188.988C318.058 184.453 316.322 179.976 314.271 175.585",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.342 186.85C342.093 185.892 341.709 184.942 341.192 184.031C337.97 178.452 330.838 176.544 325.258 179.765C321.787 181.769 319.746 185.278 319.458 188.988",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.342 186.85C343.684 191.826 341.594 197.271 336.916 199.966C331.596 203.042 324.865 201.432 321.462 196.438",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.982 195.699C321.136 195.957 321.299 196.188 321.462 196.438",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.724 211.335C323.638 212.534 322.986 213.665 321.865 214.316C321.404 214.575 320.916 214.729 320.417 214.786",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.051 175.154C314.051 175.164 314.07 175.173 314.07 175.183C314.089 175.193 314.089 175.193 314.098 175.212C314.127 175.269 314.165 175.336 314.185 175.404C314.214 175.461 314.243 175.519 314.272 175.586",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.989 173.841H308.998",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.051 175.154C313.006 173.418 310.753 172.824 308.999 173.841",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.487 204.298C264.745 201.336 266.375 198.546 269.098 196.897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.27 196.772C269.251 196.791 269.222 196.801 269.203 196.82C269.165 196.849 269.137 196.878 269.098 196.897",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.783 207.634C264.487 206.532 264.39 205.41 264.487 204.298",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.362 214.786H274.342",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.342 214.786C271.178 214.863 268.082 213.377 266.183 210.655",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.783 207.634C265.004 208.43 265.311 209.216 265.743 209.964C265.877 210.204 266.03 210.434 266.183 210.655",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.097 196.897L269.088 196.887",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.918 165.711L304.598 165.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.707 188.346L303.918 165.711",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.189 175.48L251.295 175.298L274.227 135.579",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.221 159.921C305.403 160.16 305.567 160.419 305.739 160.678",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.315 148.905C299.556 152.385 302.528 156.066 305.222 159.921",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.298 134.189C279.423 134.285 279.547 134.361 279.672 134.448",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.87 143.46C287.39 140.229 283.651 137.218 279.673 134.448",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.612 130.163C308.912 129.453 308.116 128.821 307.206 128.293C301.626 125.082 294.494 126.989 291.272 132.569C289.268 136.04 289.259 140.105 290.87 143.46",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.612 130.163C313.265 133.796 314.175 139.558 311.471 144.237C308.404 149.558 301.769 151.532 296.314 148.906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.538 148.503C295.797 148.656 296.057 148.781 296.315 148.905",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.739 160.677C306.257 161.751 306.257 163.065 305.614 164.186C305.346 164.647 304.991 165.02 304.598 165.317",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26 134.17C279.27 134.18 279.289 134.18 279.299 134.189C279.308 134.199 279.327 134.199 279.337 134.208C279.462 134.275 279.557 134.361 279.673 134.448",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.227 135.579V135.57",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.26 134.17C277.486 133.202 275.253 133.806 274.227 135.57",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.911 184.204C249.655 181.5 249.674 178.279 251.199 175.49",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.295 175.298C251.256 175.355 251.237 175.422 251.199 175.49",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.838 186.937C252.033 186.131 251.382 185.211 250.911 184.204",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.708 188.346L264.688 188.355",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.688 188.355C261.994 190.004 258.572 190.263 255.561 188.854",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.838 186.937C253.423 187.521 254.084 188.049 254.832 188.48C255.072 188.614 255.311 188.739 255.561 188.854",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.198 175.489L251.189 175.48",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.761 131.064L266.155 130.393",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.127 170.274L265.761 131.064",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 165.894V165.673V119.818",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.997 125.398C264.276 125.523 264.544 125.666 264.822 125.801",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.786 120.307C255.331 121.707 259.741 123.414 263.997 125.398",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.708 116.079C228.842 116.098 228.996 116.108 229.14 116.118",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.338 118.323C238.708 117.268 233.972 116.53 229.14 116.118",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.925 97.4333C251.966 97.1742 250.96 97.0209 249.914 97.0209C243.472 97.0209 238.247 102.246 238.247 108.688C238.247 112.695 240.26 116.223 243.337 118.323",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.925 97.4332C257.9 98.7563 261.572 103.291 261.572 108.688C261.572 114.833 256.817 119.857 250.787 120.307",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.914 120.355C250.202 120.355 250.49 120.336 250.786 120.307",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.822 125.801C265.819 126.471 266.471 127.603 266.471 128.897C266.471 129.424 266.356 129.932 266.155 130.393",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.651 116.079C228.67 116.079 228.69 116.069 228.709 116.079C228.719 116.079 228.719 116.079 228.728 116.079C228.862 116.069 228.996 116.098 229.14 116.118",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 119.818V119.809",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.651 116.079C226.618 116.127 224.989 117.776 224.989 119.809",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.111 173.582C226.676 171.876 225.075 169.076 224.998 165.894",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.988 165.673C224.988 165.749 224.997 165.816 224.997 165.893",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14 174.991C231.047 174.694 230.022 174.215 229.111 173.582",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.127 170.274L243.117 170.295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.117 170.293C241.602 173.064 238.774 175.01 235.457 175.289",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.14 174.991C232.946 175.202 233.78 175.327 234.642 175.327C234.92 175.327 235.189 175.308 235.457 175.289",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.998 165.894H224.988",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 120.145V119.358",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 165.414V120.145",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.503 170.687L197.397 170.505L174.466 130.786",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.039 116.108C211.346 116.079 211.643 116.07 211.95 116.051",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.052 118.313C201.692 117.259 206.361 116.521 211.039 116.108",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.798 125.705C175.932 125.647 176.067 125.57 176.21 125.503",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.603 120.317C185.078 121.717 180.601 123.452 176.21 125.503",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.465 97.4332C186.506 97.6917 185.558 98.0658 184.647 98.5834C179.077 101.804 177.159 108.937 180.38 114.527C182.384 117.988 185.893 120.03 189.603 120.317",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.465 97.4332C192.441 96.0911 197.886 98.1809 200.58 102.859C203.658 108.18 202.047 114.91 197.052 118.313",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.314 118.793C196.573 118.639 196.813 118.476 197.052 118.313",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.95 116.051C213.148 116.137 214.289 116.789 214.932 117.911C215.201 118.371 215.344 118.86 215.401 119.359",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.769 125.724C175.779 125.724 175.788 125.705 175.798 125.705C175.807 125.686 175.817 125.686 175.826 125.676C175.951 125.609 176.086 125.561 176.21 125.504",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.466 130.785V130.777",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.769 125.724C174.034 126.769 173.439 129.022 174.465 130.777",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.914 175.289C201.951 175.03 199.161 173.4 197.513 170.677",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.398 170.505C197.436 170.562 197.474 170.62 197.513 170.677",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.25 174.991C207.147 175.289 206.026 175.385 204.914 175.289",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 165.414V165.434",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.401 165.433C215.478 168.596 214.002 171.693 211.27 173.591",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.25 174.991C209.046 174.771 209.831 174.464 210.58 174.033C210.819 173.899 211.049 173.745 211.27 173.592",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.512 170.677L197.503 170.686",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.326 135.857L165.934 135.177",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.961 175.068L166.326 135.857",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.095 188.585L175.913 188.48L136.194 165.548",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.536 134.554C160.785 134.372 161.034 134.209 161.293 134.036",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.521 143.46C153.01 140.219 156.682 137.247 160.536 134.553",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.795 160.515C134.881 160.381 134.977 160.237 135.063 160.103",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.075 148.905C140.854 152.385 137.834 156.134 135.063 160.103",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.778 130.163C130.078 130.863 129.436 131.658 128.919 132.569C125.698 138.149 127.605 145.282 133.185 148.503C136.655 150.506 140.721 150.516 144.076 148.905",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.778 130.163C134.422 126.51 140.174 125.599 144.852 128.303C150.172 131.371 152.147 138.005 149.521 143.46",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.127 144.236C149.271 143.977 149.396 143.719 149.521 143.46",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.293 134.036C162.377 133.518 163.681 133.518 164.802 134.16C165.263 134.429 165.636 134.783 165.933 135.176",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.795 160.515C134.805 160.486 134.805 160.467 134.824 160.438C134.891 160.323 134.987 160.218 135.063 160.103",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.795 160.515C133.817 162.289 134.431 164.532 136.194 165.548",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.819 188.863C182.126 190.119 178.895 190.1 176.105 188.575",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.913 188.48C175.98 188.519 176.038 188.538 176.105 188.576",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.551 186.937C186.756 187.742 185.826 188.394 184.819 188.863",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.961 175.068L188.97 175.088",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.97 175.087C190.62 177.78 190.888 181.203 189.469 184.214",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.551 186.937C188.136 186.351 188.663 185.69 189.095 184.942C189.239 184.703 189.353 184.463 189.468 184.214",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.104 188.575L176.095 188.585",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.427 242.857C231.719 241.956 233.837 240.719 235.735 239.214",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.473 228.822C242.562 231.113 241.325 233.231 239.83 235.129",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.745 199.956C233.847 198.45 231.729 197.214 229.437 196.303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.413 215.937C195.241 217.126 195.154 218.343 195.154 219.58C195.154 220.817 195.241 222.025 195.413 223.213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83 204.039C241.334 205.937 242.571 208.056 243.473 210.347",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.561 235.12C199.056 233.222 197.819 231.103 196.918 228.812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.977 223.223C245.15 222.034 245.236 220.817 245.236 219.58C245.236 218.343 245.15 217.135 244.977 215.946",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.57 204.03C199.065 205.928 197.829 208.047 196.918 210.329",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.645 239.214C206.543 240.709 208.661 241.946 210.943 242.857",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.838 194.798C222.649 194.625 221.432 194.538 220.195 194.538C218.958 194.538 217.75 194.625 216.562 194.798",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.829 244.362C222.64 244.534 221.432 244.62 220.196 244.62C218.959 244.62 217.742 244.534 216.553 244.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.963 196.303C208.671 197.204 206.553 198.441 204.655 199.946",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.918 210.329C196.324 207.318 193.668 205.047 190.476 205.047C186.852 205.047 183.909 207.99 183.909 211.614C183.909 215.238 186.852 218.18 190.476 218.18C192.45 218.18 194.215 217.308 195.413 215.937",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.413 223.213C193.39 220.903 189.958 220.261 187.197 221.852C184.052 223.665 182.978 227.681 184.791 230.826C186.602 233.961 190.62 235.044 193.764 233.232C195.471 232.245 196.564 230.605 196.918 228.812",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.561 235.12C197.647 234.123 194.349 235.283 192.757 238.044C190.936 241.188 192.019 245.206 195.154 247.017C198.299 248.829 202.316 247.755 204.128 244.61C205.116 242.904 205.24 240.939 204.646 239.213",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.944 242.857C207.934 243.451 205.662 246.106 205.662 249.289C205.662 252.922 208.605 255.856 212.228 255.866C215.862 255.856 218.796 252.922 218.796 249.289C218.796 247.324 217.933 245.56 216.552 244.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.829 244.362C221.518 246.385 220.876 249.817 222.467 252.578C224.279 255.722 228.297 256.796 231.441 254.984C234.585 253.172 235.658 249.155 233.847 246.01C232.86 244.304 231.22 243.211 229.427 242.857",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83 235.13C241.555 234.535 243.52 234.66 245.236 235.647C248.371 237.459 249.445 241.476 247.633 244.621C245.821 247.756 241.804 248.839 238.669 247.018C235.899 245.426 234.739 242.129 235.736 239.214",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.473 228.822C244.067 231.832 246.722 234.103 249.915 234.113C253.539 234.113 256.482 231.17 256.482 227.546C256.482 223.913 253.539 220.98 249.915 220.98C247.94 220.98 246.176 221.852 244.978 223.223",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.977 215.946C247 218.257 250.432 218.899 253.194 217.308C256.338 215.496 257.412 211.479 255.6 208.334C253.788 205.19 249.771 204.116 246.626 205.928C244.92 206.915 243.827 208.555 243.473 210.348",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.83 204.039C242.734 205.036 246.042 203.876 247.633 201.106C249.455 197.971 248.371 193.954 245.236 192.142C242.092 190.321 238.074 191.404 236.263 194.539C235.276 196.255 235.151 198.22 235.745 199.956",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.838 194.798C222.466 193.599 221.594 191.835 221.594 189.86C221.594 186.236 224.528 183.294 228.161 183.294C231.785 183.294 234.729 186.237 234.729 189.86C234.729 193.053 232.457 195.708 229.436 196.303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.562 194.797C218.872 192.775 219.514 189.343 217.923 186.582C216.111 183.437 212.094 182.364 208.95 184.175C205.815 185.987 204.731 190.004 206.553 193.149C207.53 194.855 209.17 195.948 210.963 196.303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.57 204.03C198.836 204.625 196.87 204.5 195.164 203.513C192.019 201.701 190.946 197.684 192.757 194.539C194.569 191.395 198.586 190.321 201.731 192.133C204.492 193.734 205.652 197.042 204.655 199.946",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.418 83.2542L163.977 122.206",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.026 111.775L163.977 122.205",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.418 83.2542L133.961 70.216",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.961 70.216L125.026 111.775",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 124.41L122.831 163.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8695 173.802L122.831 163.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 124.41L70.8313 133.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8313 133.346L83.8695 173.802",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2486 191.059L107.76 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2486 248.101L107.76 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2486 191.059L47.7268 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7268 219.58L79.2486 248.101",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8695 265.357L122.831 275.797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 314.749L122.831 275.797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8695 265.357L70.8313 305.814",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8313 305.814L112.39 314.749",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.026 327.385L163.977 316.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.418 355.906L163.977 316.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.026 327.385L133.961 368.944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.961 368.944L174.418 355.906",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.684 360.526L220.195 332.005",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.716 360.526L220.195 332.005",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.684 360.526L220.195 392.048",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.195 392.048L248.716 360.526",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.972 355.906L276.413 316.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.364 327.385L276.413 316.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.972 355.906L306.429 368.944",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.429 368.944L315.364 327.385",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.01 314.749L317.559 275.797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.521 265.357L317.559 275.797",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.01 314.749L369.559 305.814",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.559 305.814L356.521 265.357",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.142 248.091L332.63 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.142 191.059L332.63 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.142 248.091L392.663 219.58",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.663 219.58L361.142 191.059",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.521 173.802L317.559 163.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328 124.41L317.559 163.362",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.521 173.802L369.559 133.346",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.559 133.346L328 124.41",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.364 111.766L276.413 122.215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.972 83.2542L276.413 122.215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.364 111.766L306.429 70.216",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.429 70.216L265.972 83.2542",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 78.624L220.195 107.145",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.674 78.6332L220.195 107.145",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.706 78.624L220.195 47.1114",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.195 47.1114L191.674 78.6332",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.523 6.58765C244.028 4.69903 232.227 3.69226 220.196 3.69226C208.164 3.69226 196.362 4.69903 184.858 6.58765",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.112 52.7963C101.26 37.8695 121.9 25.8473 144.295 17.4301",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.345 143.68C413.927 121.285 401.905 100.644 386.969 82.4966",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.278 52.7963C339.121 37.8603 318.49 25.8473 296.094 17.4301",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0455 143.68C26.4627 121.285 38.4849 100.644 53.4116 82.4966",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.188 184.242C435.076 195.747 436.082 207.548 436.082 219.58C436.082 231.611 435.076 243.413 433.188 254.908",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.345 295.47C413.927 317.875 401.915 338.506 386.978 356.663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20304 184.242C5.31443 195.747 4.30766 207.548 4.30766 219.58C4.30766 231.611 5.31443 243.413 7.20304 254.917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.112 386.363C101.26 401.299 121.9 413.312 144.295 421.729",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.278 386.354C339.13 401.29 318.49 413.312 296.094 421.729",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.868 432.572C196.362 434.461 208.164 435.468 220.196 435.468C232.227 435.468 244.029 434.461 255.533 432.572",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0455 295.479C26.4627 317.874 38.4849 338.515 53.4116 356.663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.751 26.0873C210.446 26.9692 213.274 27.5926 216.198 27.88",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.193 27.88C227.117 27.5926 229.945 26.9692 232.639 26.0873",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.944 22.8277C242.456 21.3896 244.804 19.693 246.933 17.7563",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.457 17.7563C195.585 19.693 197.934 21.3896 200.446 22.8277",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.858 6.58765C185.807 8.41903 186.9 10.1636 188.108 11.8123",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.523 6.58765C254.574 8.41903 253.49 10.1636 252.282 11.8123",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.197 27.88C214.769 29.04 213.858 30.8135 213.858 32.7982C213.858 36.2972 216.695 39.1348 220.195 39.1348C223.694 39.1348 226.532 36.2972 226.532 32.7982C226.532 30.8135 225.622 29.04 224.193 27.88",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.639 26.0873C231.814 27.7267 231.7 29.7113 232.505 31.523C233.924 34.7255 237.671 36.163 240.874 34.7347C244.066 33.3156 245.505 29.5673 244.086 26.3649C243.281 24.5532 241.718 23.307 239.945 22.827",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.933 17.7562C246.847 19.5876 247.547 21.4571 249.023 22.7802C251.621 25.1193 255.629 24.9181 257.978 22.3101C260.317 19.7119 260.106 15.7052 257.508 13.3655C256.032 12.0325 254.105 11.5248 252.283 11.8122",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.108 11.8122C186.286 11.5248 184.359 12.0325 182.882 13.3655C180.284 15.7045 180.074 19.7119 182.413 22.3101C184.762 24.9181 188.769 25.1292 191.367 22.7802C192.843 21.4571 193.543 19.5975 193.457 17.7562",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.446 22.8277C198.673 23.3071 197.11 24.5532 196.305 26.3748C194.876 29.5674 196.324 33.3157 199.516 34.7348C202.718 36.1631 206.466 34.7249 207.885 31.5231C208.691 29.7114 208.576 27.7268 207.751 26.0874",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.668 58.2319C115.449 57.6473 118.209 56.7747 120.884 55.5667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.806 51.56C130.193 49.8535 132.331 47.907 134.229 45.7889",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.445 31.4271C141.564 34.1692 140.375 36.8148 138.917 39.3169",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1212 58.1649C98.9397 58.7784 101.826 59.0756 104.721 59.0658",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5286 55.6917C86.6591 54.8671 84.8474 53.9089 83.112 52.7963",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.094 23.6043C144.324 21.5624 144.391 19.5009 144.295 17.4301",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.884 55.5673C120.233 57.2836 120.319 59.2676 121.316 60.9932C123.06 64.0227 126.943 65.0578 129.973 63.3132C133.002 61.5587 134.038 57.6855 132.293 54.6467C131.305 52.9304 129.628 51.8566 127.806 51.5593",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.229 45.7883C134.325 47.6197 135.227 49.4031 136.828 50.5624C139.656 52.624 143.625 51.9907 145.686 49.1631C147.738 46.3347 147.114 42.3661 144.277 40.3144C142.676 39.1452 140.701 38.848 138.918 39.3175",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.446 31.4271C143.279 33.0566 144.823 34.3225 146.76 34.7348C150.183 35.4634 153.547 33.2775 154.276 29.8548C155.004 26.4228 152.818 23.0579 149.396 22.3385C147.46 21.9262 145.532 22.4437 144.094 23.6043",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5286 55.6917C86.803 56.3532 85.3839 57.7624 84.7704 59.6412C83.6966 62.9772 85.5181 66.5532 88.8449 67.627C92.1716 68.7107 95.7477 66.8892 96.8307 63.5624C97.4443 61.6738 97.1181 59.7083 96.1212 58.1649",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.721 59.0665C103.417 60.3705 102.698 62.2301 102.899 64.2049C103.263 67.6849 106.389 70.2061 109.869 69.8418C113.349 69.4775 115.88 66.3526 115.506 62.872C115.305 60.9071 114.212 59.2388 112.669 58.232",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4037 133.614C48.5224 131.716 50.4683 129.578 52.1846 127.191",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8474 112.053C58.2628 114.833 57.3901 117.594 56.1821 120.269",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6818 104.106C59.691 101.201 59.3938 98.3249 58.7802 95.5065",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9329 138.302C37.4307 139.759 34.7846 140.948 32.043 141.83",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.307 87.904C55.4824 86.0443 54.5242 84.232 53.4116 82.4966",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0455 143.68C20.1163 143.776 22.1772 143.709 24.2196 143.488",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1821 120.269C57.8984 119.617 59.8923 119.703 61.608 120.7C64.6375 122.445 65.6726 126.328 63.9286 129.357C62.1741 132.386 58.3009 133.422 55.2621 131.677C53.5458 130.68 52.4726 129.012 52.1852 127.19",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8473 112.053C59.8541 113.596 61.5218 114.689 63.4873 114.89C66.9673 115.255 70.0929 112.733 70.4572 109.253C70.8215 105.773 68.3002 102.648 64.8202 102.284C62.8455 102.082 60.9858 102.801 59.6818 104.105",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7803 95.5064C60.3237 96.5033 62.2892 96.8295 64.1778 96.2159C67.5046 95.1322 69.3261 91.5569 68.2425 88.2301C67.1686 84.9033 63.5926 83.0818 60.2566 84.1556C58.3772 84.7692 56.968 86.1882 56.3071 87.9039",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2196 143.489C23.0695 144.917 22.5421 146.844 22.9544 148.781C23.683 152.213 27.0479 154.389 30.4701 153.661C33.8929 152.942 36.0787 149.577 35.3501 146.145C34.9378 144.208 33.6824 142.665 32.0424 141.831",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9329 138.302C39.4627 140.085 39.76 142.06 40.9298 143.661C42.9815 146.498 46.9501 147.122 49.7784 145.07C52.616 143.009 53.2393 139.04 51.1784 136.212C50.0184 134.61 48.235 133.71 46.4043 133.614",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4953 223.577C28.2079 226.501 27.5944 229.329 26.7027 232.023",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4953 215.582C28.2079 212.658 27.5944 209.83 26.7027 207.136",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.443 199.831C22.0049 197.319 20.3083 194.97 18.3717 192.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4529 239.329C22.0049 241.841 20.3083 244.19 18.3717 246.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4277 251.667C10.7784 252.875 9.03381 253.968 7.20242 254.917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20306 184.242C9.03444 185.191 10.7791 186.284 12.4283 187.492",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4953 223.577C29.6646 225.006 31.4289 225.916 33.4135 225.916C36.9132 225.916 39.7507 223.079 39.7507 219.58C39.7507 216.08 36.9132 213.243 33.4135 213.243C31.4289 213.243 29.6553 214.154 28.4953 215.582",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7027 207.136C28.3421 207.961 30.3359 208.076 32.1384 207.27C35.3403 205.851 36.7784 202.103 35.3593 198.9C33.931 195.708 30.1821 194.27 26.9901 195.689C25.1686 196.494 23.9316 198.057 23.443 199.83",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3717 192.842C20.2123 192.928 22.072 192.228 23.3951 190.752C25.744 188.154 25.5329 184.146 22.9255 181.797C20.3274 179.458 16.32 179.669 13.9809 182.268C12.6486 183.744 12.1403 185.671 12.4283 187.492",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4277 251.667C12.1495 253.489 12.648 255.415 13.9803 256.892C16.3194 259.49 20.3267 259.7 22.9347 257.361C25.5329 255.013 25.7433 251.005 23.395 248.407C22.072 246.931 20.2123 246.231 18.3717 246.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7027 232.023C28.3421 231.199 30.336 231.084 32.1384 231.889C35.3403 233.308 36.7784 237.057 35.3593 240.258C33.931 243.451 30.1821 244.899 26.9901 243.47C25.1784 242.665 23.9317 241.102 23.4523 239.329",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1821 318.89C57.3901 321.565 58.272 324.326 58.8474 327.106",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1846 311.969C50.4683 309.582 48.5224 307.444 46.4037 305.545",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9329 300.857C37.4307 299.4 34.7846 298.211 32.043 297.329",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7802 343.653C59.3938 340.835 59.691 337.949 59.6818 335.054",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.307 351.246C55.4922 353.116 54.5242 354.927 53.4116 356.663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2196 295.671C22.1778 295.451 20.1169 295.383 18.0455 295.479",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1821 318.89C57.8984 319.543 59.8923 319.456 61.608 318.459C64.6375 316.714 65.6726 312.831 63.9286 309.802C62.1741 306.773 58.3009 305.728 55.2713 307.482C53.555 308.469 52.472 310.148 52.1846 311.969",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4036 305.546C48.235 305.45 50.0178 304.549 51.1876 302.948C53.2387 300.119 52.616 296.151 49.7778 294.089C46.9495 292.038 42.9809 292.661 40.9292 295.498C39.7593 297.1 39.4621 299.074 39.9323 300.857",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0424 297.329C33.6818 296.495 34.9378 294.952 35.3501 293.015C36.0787 289.593 33.8929 286.228 30.4701 285.499C27.0473 284.77 23.6824 286.956 22.9544 290.379C22.5421 292.316 23.0695 294.242 24.2196 295.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7803 343.653C60.3237 342.647 62.2892 342.33 64.1778 342.944C67.5138 344.027 69.3261 347.603 68.2523 350.93C67.1686 354.257 63.5932 356.078 60.2664 355.004C58.3778 354.391 56.9778 352.972 56.3071 351.246",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6818 335.054C60.9858 336.358 62.8455 337.077 64.8202 336.876C68.3002 336.511 70.8215 333.386 70.4572 329.906C70.0929 326.425 66.9772 323.895 63.4873 324.269C61.5218 324.47 59.8541 325.563 58.8473 327.106",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23 393.371C132.332 391.252 130.193 389.306 127.816 387.59",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.884 383.593C118.21 382.385 115.458 381.513 112.668 380.927",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.721 380.093C101.825 380.084 98.9397 380.381 96.1212 380.994",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.445 407.732C141.564 404.99 140.385 402.345 138.917 399.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.104 415.555C144.324 417.597 144.391 419.658 144.296 421.729",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.112 386.363C84.8474 385.251 86.6591 384.292 88.5286 383.468",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.816 387.59C129.628 387.303 131.305 386.229 132.293 384.513C134.047 381.474 133.002 377.601 129.973 375.846C126.943 374.101 123.07 375.137 121.316 378.166C120.329 379.882 120.233 381.876 120.884 383.592",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.668 380.927C114.212 379.921 115.305 378.252 115.506 376.287C115.879 372.807 113.349 369.682 109.868 369.317C106.388 368.953 103.273 371.474 102.908 374.954C102.697 376.929 103.417 378.789 104.72 380.093",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.1212 380.994C97.1181 379.451 97.4443 377.485 96.8308 375.597C95.7477 372.27 92.1717 370.448 88.8449 371.532C85.5181 372.606 83.6966 376.182 84.7803 379.518C85.384 381.397 86.8129 382.807 88.5286 383.468",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.446 407.732C143.279 406.093 144.823 404.837 146.769 404.425C150.192 403.696 153.557 405.882 154.286 409.305C155.014 412.727 152.828 416.092 149.406 416.83C147.46 417.233 145.533 416.705 144.104 415.555",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.918 399.842C140.7 400.312 142.676 400.015 144.286 398.845C147.114 396.794 147.737 392.825 145.686 389.996C143.625 387.159 139.665 386.535 136.827 388.597C135.226 389.757 134.334 391.54 134.229 393.371",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.649 413.073C229.945 412.181 227.117 411.567 224.193 411.279",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.197 411.279C213.273 411.567 210.455 412.181 207.751 413.073",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.457 421.403C195.585 419.467 197.934 417.77 200.446 416.332",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.934 421.403C244.805 419.467 242.457 417.77 239.945 416.322",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.868 432.572C185.817 430.741 186.9 428.996 188.108 427.348",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.532 432.572C254.583 430.741 253.49 428.996 252.282 427.348",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.193 411.279C225.621 410.11 226.532 408.346 226.532 406.361C226.532 402.862 223.694 400.025 220.195 400.025C216.695 400.025 213.858 402.862 213.858 406.361C213.858 408.346 214.769 410.11 216.197 411.279",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.751 413.073C208.576 411.433 208.691 409.439 207.886 407.637C206.466 404.435 202.718 402.997 199.516 404.416C196.324 405.844 194.886 409.593 196.305 412.786C197.119 414.607 198.673 415.844 200.446 416.333",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.457 421.403C193.543 419.562 192.844 417.703 191.367 416.38C188.769 414.031 184.762 414.242 182.423 416.849C180.074 419.447 180.285 423.455 182.883 425.794C184.359 427.127 186.287 427.634 188.108 427.347",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.282 427.347C254.104 427.625 256.031 427.127 257.507 425.794C260.105 423.455 260.316 419.447 257.977 416.839C255.629 414.241 251.631 414.031 249.023 416.379C247.556 417.702 246.847 419.562 246.933 421.402",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.944 416.322C241.727 415.843 243.281 414.597 244.085 412.785C245.514 409.592 244.076 405.844 240.873 404.415C237.671 402.996 233.933 404.434 232.504 407.636C231.698 409.438 231.814 411.432 232.647 413.071",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.722 380.927C324.941 381.503 322.181 382.385 319.506 383.593",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.584 387.59C310.197 389.306 308.058 391.252 306.161 393.371",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.954 407.732C298.827 404.99 300.016 402.345 301.473 399.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.268 380.994C341.45 380.381 338.564 380.084 335.669 380.093",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.295 415.555C296.066 417.597 295.999 419.658 296.094 421.729",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.278 386.354C355.543 385.251 353.731 384.283 351.862 383.468",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.506 383.593C320.167 381.876 320.071 379.882 319.074 378.167C317.33 375.137 313.447 374.102 310.418 375.847C307.388 377.601 306.353 381.474 308.097 384.503C309.094 386.22 310.762 387.303 312.584 387.591",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.161 393.371C306.065 391.54 305.164 389.756 303.563 388.587C300.735 386.535 296.766 387.159 294.714 389.996C292.653 392.825 293.276 396.793 296.113 398.845C297.724 400.015 299.69 400.312 301.473 399.842",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.954 407.732C297.111 406.093 295.567 404.837 293.631 404.425C290.209 403.696 286.844 405.882 286.115 409.305C285.386 412.727 287.572 416.092 290.995 416.821C292.931 417.233 294.858 416.706 296.296 415.555",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.862 383.468C353.587 382.797 355.006 381.397 355.619 379.508C356.693 376.181 354.871 372.605 351.545 371.522C348.218 370.449 344.642 372.26 343.559 375.597C342.945 377.476 343.271 379.451 344.268 380.994",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.669 380.094C336.973 378.79 337.692 376.93 337.491 374.955C337.127 371.475 334.001 368.954 330.521 369.318C327.042 369.682 324.52 372.798 324.884 376.287C325.095 378.253 326.179 379.921 327.722 380.928",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.996 305.546C391.868 307.434 389.922 309.582 388.215 311.959",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.543 327.106C382.127 324.316 383 321.565 384.208 318.89",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.708 335.054C380.708 337.949 381.006 340.835 381.61 343.653",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.458 300.848C402.959 299.391 405.605 298.212 408.348 297.33",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.084 351.246C384.908 353.116 385.866 354.927 386.978 356.663",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.345 295.47C420.274 295.383 418.213 295.451 416.171 295.671",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.208 318.89C382.492 319.543 380.507 319.446 378.791 318.459C375.753 316.705 374.717 312.831 376.471 309.802C378.216 306.773 382.089 305.728 385.127 307.482C386.844 308.469 387.918 310.148 388.215 311.959",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.543 327.106C380.536 325.563 378.877 324.47 376.903 324.269C373.423 323.895 370.298 326.426 369.933 329.906C369.569 333.386 372.09 336.501 375.58 336.866C377.555 337.077 379.405 336.357 380.709 335.054",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61 343.653C380.066 342.657 378.101 342.33 376.212 342.944C372.886 344.027 371.065 347.603 372.148 350.93C373.231 354.257 376.807 356.078 380.134 354.994C382.014 354.391 383.423 352.962 384.084 351.246",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17 295.671C417.33 294.243 417.849 292.316 417.445 290.37C416.707 286.947 413.342 284.761 409.92 285.49C406.498 286.218 404.311 289.583 405.04 293.006C405.452 294.953 406.708 296.495 408.348 297.33",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.458 300.848C400.937 299.074 400.63 297.1 399.46 295.489C397.409 292.661 393.44 292.028 390.612 294.09C387.774 296.151 387.151 300.111 389.212 302.948C390.372 304.55 392.156 305.441 393.996 305.546",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.895 215.582C412.183 212.658 412.796 209.83 413.687 207.127",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.895 223.577C412.183 226.501 412.805 229.32 413.687 232.023",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.947 239.329C418.385 241.841 420.082 244.19 422.018 246.318",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.018 192.832C420.082 194.97 418.385 197.319 416.947 199.831",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.962 187.492C429.611 186.284 431.356 185.191 433.187 184.242",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.962 251.667C429.611 252.875 431.356 253.958 433.187 254.908",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.895 215.582C410.735 214.154 408.961 213.243 406.977 213.243C403.477 213.243 400.64 216.081 400.64 219.58C400.64 223.079 403.477 225.916 406.977 225.916C408.962 225.916 410.735 225.006 411.895 223.577",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.687 232.023C412.048 231.199 410.063 231.075 408.252 231.889C405.05 233.308 403.612 237.057 405.04 240.259C406.459 243.451 410.207 244.889 413.41 243.47C415.221 242.655 416.468 241.102 416.947 239.329",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.018 246.318C420.187 246.231 418.317 246.931 416.995 248.407C414.655 251.006 414.857 255.013 417.465 257.352C420.063 259.701 424.07 259.49 426.419 256.892C427.742 255.415 428.25 253.489 427.963 251.667",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.962 187.492C428.25 185.671 427.742 183.744 426.409 182.268C424.07 179.669 420.063 179.459 417.465 181.797C414.857 184.137 414.646 188.144 416.995 190.742C418.317 192.218 420.178 192.928 422.018 192.832",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.947 199.831C416.468 198.048 415.222 196.495 413.4 195.689C410.207 194.261 406.459 195.699 405.04 198.901C403.612 202.103 405.05 205.842 408.252 207.271C410.063 208.076 412.048 207.961 413.687 207.127",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.208 120.269C383 117.585 382.118 114.833 381.543 112.053",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.215 127.191C389.922 129.578 391.868 131.716 393.987 133.614",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.458 138.302C402.969 139.759 405.605 140.948 408.348 141.82",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61 95.5065C380.996 98.3249 380.699 101.201 380.708 104.106",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.084 87.9132C384.898 86.0437 385.866 84.232 386.969 82.4966",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.17 143.479C418.212 143.709 420.274 143.776 422.344 143.68",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.208 120.269C382.492 119.607 380.507 119.703 378.782 120.691C375.753 122.446 374.717 126.328 376.461 129.358C378.217 132.387 382.089 133.422 385.118 131.678C386.844 130.681 387.918 129.012 388.215 127.191",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.986 133.614C392.155 133.71 390.372 134.601 389.212 136.212C387.15 139.041 387.783 143.009 390.611 145.061C393.439 147.122 397.409 146.498 399.46 143.662C400.63 142.05 400.936 140.086 400.457 138.303",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.348 141.82C406.718 142.664 405.452 144.207 405.04 146.144C404.311 149.567 406.497 152.932 409.92 153.66C413.352 154.389 416.717 152.203 417.445 148.78C417.848 146.844 417.33 144.917 416.17 143.479",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.61 95.5064C380.066 96.5033 378.101 96.8295 376.212 96.2159C372.886 95.1322 371.065 91.5569 372.138 88.2301C373.221 84.9033 376.797 83.0818 380.133 84.1556C382.013 84.7692 383.422 86.1882 384.084 87.9138",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.708 104.106C379.405 102.802 377.545 102.083 375.57 102.284C372.09 102.649 369.568 105.774 369.932 109.254C370.297 112.734 373.422 115.255 376.902 114.891C378.867 114.68 380.535 113.597 381.542 112.054",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.584 51.56C310.197 49.8535 308.058 47.9071 306.161 45.7791",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.506 55.5674C322.181 56.7655 324.941 57.6474 327.722 58.2326",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.669 59.0566C338.574 59.0664 341.45 58.7692 344.269 58.1649",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.945 31.4271C298.827 34.1692 300.006 36.8148 301.473 39.3169",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.871 55.6917C353.731 54.8671 355.543 53.9089 357.278 52.7963",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.295 23.6043C296.066 21.5624 295.999 19.5009 296.094 17.4301",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.584 51.5599C310.762 51.8572 309.084 52.931 308.097 54.6473C306.353 57.6861 307.388 61.5593 310.418 63.3039C313.447 65.0584 317.33 64.0227 319.074 60.9839C320.061 59.2676 320.167 57.2836 319.506 55.5673",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.722 58.232C326.178 59.2388 325.085 60.8972 324.884 62.872C324.52 66.352 327.042 69.4775 330.521 69.8418C334.001 70.2061 337.127 67.6849 337.491 64.1951C337.692 62.2203 336.973 60.3698 335.669 59.0566",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.268 58.1649C343.271 59.7083 342.946 61.6738 343.559 63.5624C344.642 66.8892 348.218 68.7107 351.545 67.627C354.872 66.544 356.694 62.968 355.62 59.6412C355.006 57.7624 353.587 56.3532 351.871 55.6917",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.945 31.427C297.111 33.0664 295.567 34.3224 293.622 34.7347C290.199 35.4633 286.843 33.2774 286.105 29.8547C285.386 26.4319 287.572 23.067 290.994 22.3291C292.93 21.9267 294.858 22.4442 296.295 23.6042",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.473 39.3169C299.69 38.8375 297.714 39.1446 296.103 40.3138C293.275 42.3655 292.653 46.3348 294.704 49.1624C296.765 52 300.735 52.6234 303.563 50.5618C305.164 49.3926 306.065 47.6184 306.161 45.7778",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89 98.5452C353.29 97.1741 354.162 95.2665 354.162 93.1575C354.162 88.9871 350.778 85.6123 346.617 85.6123C344.566 85.6123 342.715 86.4271 341.354 87.7502",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.713 98.411C329.227 99.7913 328.297 101.747 328.297 103.933C328.297 108.103 331.671 111.478 335.842 111.478C337.951 111.478 339.858 110.605 341.23 109.215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.354 87.7501C339.983 86.2738 338.018 85.3439 335.842 85.3439C331.672 85.3439 328.297 88.7187 328.297 92.8892C328.297 95.075 329.227 97.0307 330.713 98.411",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.89 98.5452C353.29 99.9162 354.162 101.824 354.162 103.933C354.162 108.103 350.778 111.478 346.617 111.478C344.498 111.478 342.601 110.605 341.229 109.215",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.738 48.9138C274.255 47.0252 274.054 44.9452 273 43.1138C270.919 39.499 266.308 38.2726 262.694 40.3526C260.92 41.3784 259.732 43.0079 259.214 44.8295",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.321 59.3828C254.727 61.3194 254.899 63.4855 255.983 65.3748C258.073 68.9889 262.684 70.2258 266.298 68.1354C268.12 67.0812 269.337 65.3748 269.826 63.4855",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.214 44.8295C257.278 44.2449 255.121 44.4172 253.231 45.5002C249.617 47.5901 248.38 52.2018 250.461 55.8159C251.554 57.7046 253.346 58.9316 255.321 59.3821",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.738 48.9139C275.626 49.4031 277.333 50.6203 278.388 52.4419C280.478 56.0566 279.241 60.6677 275.627 62.7483C273.796 63.8123 271.716 64.0043 269.826 63.4862",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.225 45.0116C180.736 43.1138 179.528 41.4073 177.697 40.3525C174.082 38.2725 169.471 39.5088 167.391 43.1138C166.365 44.8873 166.145 46.9002 166.614 48.7415",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.516 63.2842C170.966 65.259 172.203 67.0523 174.092 68.1446C177.706 70.2252 182.318 68.9883 184.398 65.3741C185.452 63.5526 185.654 61.4627 185.126 59.5741",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.614 48.7409C164.639 49.1914 162.856 50.4184 161.763 52.3071C159.683 55.9212 160.919 60.5323 164.524 62.6228C166.422 63.7058 168.58 63.8787 170.516 63.2843",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.225 45.0117C183.113 44.4843 185.203 44.6855 187.025 45.7403C190.639 47.8203 191.876 52.4412 189.786 56.0461C188.732 57.8775 187.025 59.0947 185.127 59.5741",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1606 87.8843C97.7895 86.4849 95.891 85.6123 93.7729 85.6123C89.6123 85.6123 86.2283 88.9969 86.2283 93.1575C86.2283 95.2092 87.043 97.0591 88.3661 98.4209",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0258 109.062C100.407 110.548 102.362 111.478 104.548 111.478C108.719 111.478 112.093 108.103 112.093 103.933C112.093 101.824 111.23 99.9162 109.831 98.5452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3655 98.4202C86.8892 99.7913 85.9593 101.756 85.9593 103.933C85.9593 108.103 89.3335 111.478 93.5039 111.478C95.6898 111.478 97.6455 110.548 99.0258 109.062",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1606 87.8843C100.532 86.4849 102.439 85.6123 104.548 85.6123C108.719 85.6123 112.093 88.9969 112.093 93.1575C112.093 95.2763 111.23 97.1741 109.831 98.5452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5292 166.037C47.6406 165.519 45.56 165.711 43.7292 166.775C40.1249 168.855 38.888 173.467 40.9686 177.081C41.9944 178.855 43.624 180.044 45.4553 180.561",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0073 184.454C61.9341 185.048 64.1009 184.876 65.9993 183.792C69.6036 181.702 70.8406 177.09 68.7606 173.476C67.7058 171.645 65.9993 170.438 64.1015 169.948",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4548 180.561C44.8603 182.498 45.0326 184.655 46.1261 186.543C48.2061 190.158 52.8178 191.394 56.432 189.314C58.3206 188.221 59.5575 186.428 60.008 184.454",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5292 166.037C50.0178 164.148 51.2357 162.442 53.0572 161.387C56.6713 159.297 61.283 160.534 63.3729 164.148C64.4277 165.98 64.6289 168.06 64.1015 169.948",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.627 258.551C43.7292 259.039 42.0227 260.247 40.9679 262.079C38.8873 265.693 40.1243 270.304 43.7286 272.385C45.5021 273.41 47.5156 273.631 49.3563 273.161",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9095 269.259C65.8744 268.809 67.6676 267.572 68.7606 265.683C70.8406 262.069 69.6043 257.457 65.9993 255.377C64.1679 254.322 62.0781 254.121 60.1993 254.649",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3569 273.161C49.8073 275.136 51.0344 276.919 52.923 278.012C56.5378 280.093 61.1489 278.856 63.2387 275.251C64.3316 273.353 64.5046 271.186 63.9101 269.26",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.627 258.551C45.1002 256.662 45.3015 254.572 46.3556 252.751C48.4362 249.137 53.0572 247.9 56.6615 249.99C58.4929 251.044 59.7101 252.751 60.1993 254.649",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4997 340.614C87.0997 341.985 86.2277 343.884 86.2277 346.002C86.2277 350.162 89.6123 353.546 93.7723 353.546C95.824 353.546 97.6744 352.722 99.0357 351.409",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.687 340.749C111.163 339.368 112.103 337.403 112.103 335.226C112.103 331.057 108.719 327.682 104.548 327.682C102.439 327.682 100.532 328.545 99.1698 329.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0356 351.409C100.417 352.886 102.372 353.816 104.548 353.816C108.719 353.816 112.103 350.441 112.103 346.271C112.103 344.085 111.163 342.119 109.687 340.749",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4997 340.614C87.0997 339.243 86.2277 337.335 86.2277 335.226C86.2277 331.057 89.6123 327.682 93.7723 327.682C95.8911 327.682 97.7987 328.545 99.1698 329.945",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.662 390.245C166.135 392.134 166.336 394.215 167.391 396.045C169.471 399.65 174.092 400.887 177.697 398.807C179.47 397.781 180.668 396.151 181.177 394.32",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.078 379.767C185.673 377.84 185.49 375.674 184.407 373.775C182.317 370.171 177.706 368.934 174.091 371.015C172.27 372.069 171.052 373.775 170.563 375.674",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.177 394.32C183.113 394.914 185.28 394.742 187.159 393.649C190.773 391.569 192.01 386.958 189.929 383.343C188.836 381.455 187.044 380.218 185.078 379.767",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.662 390.245C164.764 389.757 163.057 388.539 162.003 386.708C159.913 383.103 161.149 378.492 164.764 376.402C166.595 375.348 168.676 375.146 170.564 375.673",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.165 394.148C259.655 396.046 260.863 397.752 262.693 398.807C266.308 400.887 270.919 399.65 273.009 396.046C274.025 394.272 274.246 392.259 273.776 390.418",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.874 375.866C269.424 373.9 268.187 372.108 266.298 371.015C262.694 368.934 258.073 370.171 255.993 373.775C254.938 375.607 254.737 377.696 255.263 379.575",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.777 390.418C275.751 389.968 277.534 388.74 278.628 386.852C280.708 383.238 279.471 378.617 275.866 376.537C273.978 375.444 271.812 375.271 269.875 375.866",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.166 394.148C257.277 394.675 255.197 394.474 253.366 393.419C249.751 391.339 248.514 386.717 250.604 383.113C251.659 381.282 253.366 380.065 255.263 379.575",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.229 351.275C342.601 352.674 344.499 353.547 346.618 353.547C350.788 353.547 354.162 350.163 354.162 345.993C354.162 343.951 353.348 342.1 352.025 340.739",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.364 330.088C339.984 328.612 338.028 327.672 335.842 327.672C331.681 327.672 328.297 331.056 328.297 335.226C328.297 337.336 329.169 339.244 330.559 340.605",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.025 340.739C353.501 339.359 354.431 337.403 354.431 335.226C354.431 331.056 351.057 327.672 346.885 327.672C344.7 327.672 342.745 328.612 341.364 330.088",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.23 351.275C339.858 352.674 337.951 353.547 335.842 353.547C331.672 353.547 328.297 350.163 328.297 345.993C328.297 343.884 329.169 341.976 330.559 340.605",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.861 273.113C392.75 273.64 394.83 273.439 396.661 272.385C400.275 270.304 401.512 265.683 399.422 262.079C398.396 260.305 396.767 259.106 394.945 258.599",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.383 254.697C378.455 254.102 376.289 254.284 374.4 255.367C370.786 257.457 369.549 262.069 371.63 265.683C372.694 267.505 374.4 268.722 376.289 269.211",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.945 258.599C395.53 256.662 395.358 254.496 394.274 252.617C392.184 249.002 387.572 247.765 383.958 249.846C382.07 250.939 380.842 252.732 380.382 254.697",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.861 273.113C390.372 275.011 389.164 276.718 387.333 277.772C383.719 279.862 379.108 278.625 377.017 275.011C375.963 273.18 375.762 271.1 376.289 269.211",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.763 180.609C396.661 180.121 398.367 178.913 399.422 177.081C401.512 173.467 400.275 168.855 396.661 166.765C394.887 165.749 392.874 165.529 391.033 165.989",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.49 169.9C374.516 170.351 372.723 171.588 371.63 173.476C369.55 177.081 370.786 181.702 374.401 183.782C376.222 184.836 378.312 185.038 380.191 184.511",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.034 165.989C390.583 164.023 389.356 162.241 387.468 161.148C383.853 159.067 379.242 160.294 377.152 163.908C376.059 165.797 375.896 167.964 376.49 169.9",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.763 180.609C395.29 182.498 395.098 184.578 394.034 186.409C391.954 190.023 387.332 191.26 383.728 189.17C381.897 188.116 380.679 186.409 380.191 184.511",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 440,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiber);
export default __webpack_public_path__ + "static/media/liber.72f89d6460ad7aef4fe5cceacabb2a58.svg";
export { ForwardRef as ReactComponent };